import { Instance, types } from "mobx-state-tree";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { LeadTopicsUpdatePayload } from "@fidget/common/models/chat/chatItems";
import { ChatItemType } from "../ChatItemType";
import { BaseChatItem } from "./BaseChatItem";

export const TopicsChangeChatItem = types
  .compose(
    "TopicsChangeChatItem",
    BaseChatItem,
    types.model({
      type: types.literal(ChatItemType.TopicsChange),
      eventData: types.frozen<LeadTopicsUpdatePayload>()
    })
  )
  .views((self) => ({
    get text() {
      const { topics } = self.eventData;

      switch (topics.length) {
        case 0:
          return (
            intl.formatMessage("conversation.event.topicsChange.topic") +
            intl.formatMessage("conversation.event.topicsChange.undefined")
          );
        case 1:
          return (
            intl.formatMessage("conversation.event.topicsChange.topic") +
            "<b>" +
            topics.join(", ") +
            "</b>"
          );
        default:
          return (
            intl.formatMessage("conversation.event.topicsChange.topics") +
            "<b>" +
            topics.join(", ") +
            "</b>"
          );
      }
    }
  }));

export interface ITopicsChangeChatItem extends Instance<typeof TopicsChangeChatItem> {}
